import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Pagination, Stack, Typography } from "@mui/material";

import { PATH_DASHBOARD } from "@app/routes/paths";
import { imageSource, Strings } from "@app/constants";
import { VehicleCard } from "@app/components";
import { style } from "../style";
import { selectGetWishlistProducts } from "../selector";
import { useRequestState } from "@app/hooks";
import { useEffect, useState } from "react";
import { getWishlist } from "../slice";

const Wishlist = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data } = useRequestState({
    stateSelector: selectGetWishlistProducts,
  });

  useEffect(() => {
    dispatch(getWishlist({ page: 1, limit: 10 }));
  }, []);

  const handlePageChange = (newPage: any) => {
    dispatch(getWishlist({ page: newPage, limit: 10 }));
  };

  return (
    <Stack sx={style.container}>
      <Typography variant="h3" sx={style.heading}>
        {Strings.wishlist.wishlist}
      </Typography>
      <Stack sx={style.wishlistCards}>
        {data?.data?.length === 0 ? (
          <Stack
            sx={{
              width: "100%",
              height: 200,
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: 24 }}>
              {Strings.wishlist.noProductsFound}
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate(PATH_DASHBOARD.productListPage)}
            >
              {Strings.button.shopNow}
            </Button>
          </Stack>
        ) : (
          data?.data?.map((item: any) => {
            const car = item?.car;
            const normalizedVehicle = {
              id: car?.id,
              image: car?.images?.[0]?.url || "",
              name: `${car?.brand?.name || ""} ${
                car?.model?.name || ""
              }`.trim(),
              price: car?.price,
              transmission: car?.transmission,
              engineType: car?.engineType,
              driven: car?.driven,
              brand: car?.brand?.name,
              model: car?.model?.name,
              isSold: car?.isSold,
            };

            return (
              <VehicleCard
                key={normalizedVehicle.id}
                vehicle={normalizedVehicle}
                onViewDetails={() =>
                  navigate(`${PATH_DASHBOARD.productDetail}/${car?.id}`)
                }
              />
            );
          })
        )}
      </Stack>
      <Stack
        sx={{
          mt: 2,
          flexDirection: "row",
          justifyContent: "end",
          px: 2,
        }}
      >
        {data?.data?.length !== 0 && (
          <Pagination
            count={data?.pagination?.totalPages || 1}
            page={data?.pagination?.currentPage || 1}
            onChange={(e, value) => handlePageChange(value)}
          />
        )}
      </Stack>
    </Stack>
  );
};

export { Wishlist };
